<template>
  <el-cascader :options="options" :placeholder="inputPlaceholder" @change="changeProduct" :props="{ checkStrictly: true }"
    clearable v-model="result" ref="cascader"></el-cascader>
</template>

<script>
import { areaTree } from "@/api/CaseManage";
export default {
  data() {
    return {
      options: [],
      result: []
    };
  },
  watch: {
    DefaultValue: {
      // 每个属性值发生变化就会调用这个函数
      handler(newVal, oldVal) {
        this.DefaultValue = newVal;
        this.result = this.DefaultValue
      },
      // 立即处理 进入页面就触发
      immediate: true,
      // 深度监听 属性的变化
      deep: true
    },
  },
  props: {
    inputPlaceholder: {
      type: String,
      default: "请选择省市区"
    },
    prop: {
      type: String,
      default: ""
    },
    DefaultValue: {
      type: Array,
      default: () => {
        return []
      }
    },
    isSupportArea: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    // 切换商品类型
    changeProduct(node) {
      let city = null;
      let district = null;
      let province = null;
      this.result = [];
      console.log(node, "node");
      if (this.isSupportArea) {
        if (node.length == 1) {
          city = node[0];
          this.result = [city];
        } else if (node.length == 2) {
          city = node[0];
          district = node[1];
          this.result = [city, district];
        } else if (node.length == 3) {
          city = node[0];
          district = node[1];
          province = node[2];
          this.result = [city, district, province];
        } else {
          this.result = [];
        }
      } else {
        if (node.length == 1) {
          city = node[0];
          this.result = [city];
        } else if (node.length == 2) {
          city = node[0];
          district = node[1];
          this.result = [city, district];
        } else {
          this.result = [];
        }
      }
      console.log(this.result, "111111111");
      this.$emit("changeP", this.result);
      // this.$emit("input", result);
    },
    async initOptions() {
      let list = [];
      if (list.length <= 0) {
        await areaTree({}).then(ret => {
          if (ret.code === 0) {
            list = ret.data || [];
          }
        });
      }
      list = list.map(item => {
        let obj = {
          label: item.name,
          value: item.code
        };
        obj.children = item.items.map(item1 => {
          let obj = {
            label: item1.name,
            value: item1.code
          };
          if (this.isSupportArea) {
            obj.children = item1.items?.map(item2 => {
              let obj = {
                label: item2.name,
                value: item2.code
              };
              return obj;
            });
          }
          return obj;
        });
        return obj;
      });
      this.options = list;
    },
    resetCascaderInput() {
      this.result = [];
    }
  },
  mounted() {
    this.initOptions();
  }
};
</script>

<style lang="scss" scoped></style>
